import React from 'react';
import ReactDOM from 'react-dom/client';
import Routing from './routes/routes';
import 'semantic-ui-css/semantic.min.css';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Routing />);
